export { Ri5UcsService } from './ucs/ri5-ucs.service';
export { UcExternalProperties } from './ucs/uc-external-properties.interface';



// WEBPACK FOOTER //
// ./src/app/core/ri5-api/index.ts